import { Project } from "../stores/ProjectsStore";
import SkTechApiClient from "./base/SkTechApiClient";
import dayjs from 'dayjs';
import { AddGeneralAssignment, Test, TestLevelSetting, TestPointSetting, UserTestAssignment } from "../stores/TestsStore";

export default class TestsApiClient extends SkTechApiClient {

  public deleteAssignmentById = async (assignmentId: string): Promise<any> => {
    return await this.Delete(`/api/UserTestAssignment/${assignmentId}`)
      .then(function (response) {
        if (response.status === 200) {
          return true;
        }
        return false;
      });
  }

  public addUserTestAssignment = async (addTest: UserTestAssignment): Promise<UserTestAssignment> => {
    return await this.Post(`/api/UserTestAssignment`, addTest)
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        return error.response.data;
      });
  }

  public addGeneralUserTestAssignment = async (generalAssignments: AddGeneralAssignment): Promise<UserTestAssignment> => {
    return await this.Post(`/api/UserTestAssignment/general`, generalAssignments)
      .then((response) => {
        if(response.status === 200){
          return true;
        }
        return false;
      })
      .catch(function (error) {
        return error.response.data;
      });
  }

  public updateUserTestAssignment = async (id: number, updateAssignment: UserTestAssignment): Promise<UserTestAssignment> => {
    return await this.Put(`/api/UserTestAssignment/${id}`, updateAssignment)
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        return error.response.data;
      });
  }

  public updateTest = async (id: number, updateTest: Test): Promise<Test> => {
    return await this.Put(`/api/Test/${id}`, updateTest)
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        return error.response.data;
      });
  }

  public getAllAssignmentByCompanyId = async (companyId: string): Promise<UserTestAssignment[]> => {
    return await this.Get(`/api/UserTestAssignment/company/${companyId}`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      });
  }

  public getTestById = async (id: string): Promise<Test> => {
    return await this.Get(`/api/Test/${id}`)
      .then(function (response) {
        if (response?.status === 200) {
          return response.data;
        }
        return false;
      });
  }

  public getAssignmentById = async (id: string): Promise<UserTestAssignment> => {
    return await this.Get(`/api/UserTestAssignment/${id}`)
      .then(function (response) {
        if (response?.status === 200) {
          return response.data;
        }
        return false;
      });
  }

  public getAllAssignmentByUserId = async (userId: string): Promise<UserTestAssignment[]> => {
    return await this.Get(`/api/UserTestAssignment/user/${userId}`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      });
  }

  public addUserTestAssignmentPlan = async (assignmentsPlan: UserTestAssignment[], userId: number, overwrite: boolean = false) => {
    return await this.Post(`/api/UserTestAssignment/plan?userId=${userId}&overwrite=${overwrite}`, assignmentsPlan)
      .then((response) => {
        return response;
      })
      .catch(function (error) {
        return error.response.data;
      });
  }

  public updateUserTestAssignmentPlan = async (assignmentsPlan: UserTestAssignment[], userId: number): Promise<UserTestAssignment[]> => {
    return await this.Put(`/api/UserTestAssignment/plan?userId=${userId}`, assignmentsPlan)
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        return error.response.data;
      });
  }

  public addTest = async (addTest: Test, overwrite: boolean = false): Promise<Test> => {
    return await this.Post(`/api/Test?overwrite=${overwrite}`, addTest)
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        return error.response.data;
      });
  }

  public getAllPublic = async (): Promise<Test[]> => {
    return await this.Get(`/api/Test`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      });
  }

  public getAllPublicWithoutQuestions = async (): Promise<Test[]> => {
    return await this.Get(`/api/Test/without_questions`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      });
  }

  public getAllByCompanyId = async (companyId: string): Promise<Test[]> => {
    return await this.Get(`/api/Test/company/${companyId}`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      });
  }

  public getAllByCompanyIdWithoutQuestions = async (companyId: string): Promise<Test[]> => {
    return await this.Get(`/api/Test/company/without_questions/${companyId}`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      });
  }

  public getAllTestLevelSettings = async (): Promise<TestLevelSetting[]> => {
    return await this.Get(`/api/Test/setting/level`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      });
  }

  public getAllTestPointSettings = async (): Promise<TestPointSetting[]> => {
    return await this.Get(`/api/Test/setting/points`)
      .then(function (response) {
        if (response.status === 200) {
          return response.data;
        }
        return [];
      });
  }

  public deleteById = async (id: string): Promise<any> => {
    return await this.Delete(`/api/Test/${id}`)
      .then(function (response) {
        if (response.status === 200) {
          return true;
        }
        return false;
      });
  }

  public getProjects = async (): Promise<Project[]> => {

    return await this.Get(`/api/Tests`)
      .then(function (response) {
        if (response?.status === 200) {
          return response.data.map((el: {
            startDate: string;
          }) => {
            return {
              ...el,
              startDate: dayjs(el.startDate),
            }
          });
        }
        return false;
      });
  }

}